module.exports = __webpack_public_path__ + "static/inspector@2x-96cd99797662dec0041bfaa21a2fe596.png";


//////////////////
// WEBPACK FOOTER
// ./src/media/images/pages/features/handoff/inspector@2x.png
// module id = 2608
// module chunks = 168707334958949